/**
 * Multi-line text input with **`qz-input`** styling.
 *
 * @param options - Identity, rows, placeholder, value, disabled.
 * @returns Native **`textarea`**.
 */
export function createTextArea(
  options: Readonly<{
    id: string;
    name?: string;
    rows?: number;
    placeholder?: string;
    disabled?: boolean;
    value?: string;
  }>,
): HTMLTextAreaElement {
  const ta = document.createElement("textarea");
  ta.className = "qz-input qz-input--textarea";
  ta.rows = options.rows ?? 3;
  if (options.name !== undefined) {
    ta.name = options.name;
  }
  if (options.placeholder !== undefined) {
    ta.placeholder = options.placeholder;
  }
  if (options.disabled === true) {
    ta.disabled = true;
  }
  if (options.value !== undefined) {
    ta.value = options.value;
  }
  ta.id = options.id;
  return ta;
}
